import { UnitActivationsPage } from '@apps-common/apps/portal/pages/units/pages/activations/Index'

export const UnitActivations = () => <UnitActivationsPage />
